import { t } from "i18next";
import { useEffect } from "react";
import { useStyles } from "../../core/styles/theme";
import { scrollToTop } from "../navigation/utils/useScrollToTop";
import { OnboardingScreenContainer } from "../onboarding/OnboardingScreenContainer";
import { FormQuestion } from "./components/FormQuestion";
import { useHandleFormScreens } from "./utils/useHandleFormScreens";

export const FormsDisplayScreen = () => {
  const theme = useStyles();

  const {
    currentQuestion,
    currentQuestionIndexInForm,
    amountTotalQuestionsInForm,
    handleNextQuestion,
    isQuestionOptional,
    nextButtonDisabled,
    nextButtonText,
    nextButtonLoading,
    handlePreviousQuestion,
    hideBackButton,
    handleSkipQuestion,
  } = useHandleFormScreens();

  useEffect(() => {
    scrollToTop();
  }, [currentQuestionIndexInForm]);

  if (!currentQuestion) {
    return <div>No question available</div>;
  }

  return (
    <OnboardingScreenContainer
      handleBack={handlePreviousQuestion}
      hideBackButton={hideBackButton}
      nextButton={{
        text: nextButtonText,
        onClick: () => handleNextQuestion(false),
        disabled: nextButtonDisabled,
        loading: nextButtonLoading,
      }}
      progress={{
        currentStep: currentQuestionIndexInForm,
        numberOfSteps: amountTotalQuestionsInForm,
        progressBarFillColor: theme.colors.primary,
      }}
      textButton={
        isQuestionOptional
          ? {
              text: t("SKIP"),
              onClick: handleSkipQuestion,
              loading: nextButtonLoading,
            }
          : undefined
      }
    >
      <FormQuestion formQuestion={currentQuestion} />
    </OnboardingScreenContainer>
  );
};
